import { ErrorRecoveryActions } from "./error-recovery-actions";

export const NotFound = () => {
  return (
    <div className="flex h-screen flex-col items-center justify-center pb-40">
      <p className="text-9xl font-bold text-tw-gray-200">404</p>
      <h1 className="mt-6 text-xl font-bold text-tw-gray-400">
        ページが見つかりませんでした
      </h1>
      <p className="mt-3">
        お探しのページは存在しないか、アクセスできない状態です。
      </p>

      <ErrorRecoveryActions className="mt-12" />
    </div>
  );
};
